import React, {useState} from 'react';
import "../loginSectionComponent.scss";
import {Button} from "@mui/material";
import { useDispatch } from 'react-redux';
import {UseLogin} from "../../../api/useAuth";
import {setUserValue} from "../../../reducers/userReducer";
import { useTranslation } from "react-i18next";
import i18n from "../../../localization/i18n";

interface LoginSectionProps {
    handleLogin: (status: boolean) => void;
    handleCloseModal: () => void;
    redirectToRegistration: () => void;
}

const LoginSectionComponent = (props: LoginSectionProps) => {
    const { t } = useTranslation();
    const { language } = i18n;
    
    const dispatch = useDispatch();
    const [email, setEmail] = useState<string>("");
    const [password, setPassword] = useState<string>("");

    const handleButtonFormSubmit = async () => {
        if (email && password) {
            try {
                UseLogin({email, password, language}).then((response: any) => {
                    if (response && response.status === 200) {
                        dispatch(setUserValue({ key: "id", value: response.result.user.id }));
                        dispatch(setUserValue({ key: "name", value: response.result.user.name }));
                        dispatch(setUserValue({ key: "email", value: response.result.user.email }));
                        dispatch(setUserValue({ key: "phoneNr", value: response.result.user.mobile }));
                        dispatch(setUserValue({ key: "isAuth", value: true }));
                        dispatch(setUserValue({ key: "cartCount", value: response.result.user?.cartCount }));
                        dispatch(setUserValue({ key: "qrCodeCount", value: response.result.user?.qrCodeCount }));
                        dispatch(setUserValue({ key: "address", value: response.result.user?.address }));
                        props.handleLogin(true);
                        props.handleCloseModal();
                    }
                    else {
                        dispatch(setUserValue({ key: "id", value: "" }));
                        dispatch(setUserValue({ key: "name", value: "" }));
                        dispatch(setUserValue({ key: "email", value: "" }));
                        dispatch(setUserValue({ key: "phoneNr", value: "" }));
                        dispatch(setUserValue({ key: "isAuth", value: false }));
                        dispatch(setUserValue({ key: "cartCount", value: 0 }));
                        dispatch(setUserValue({ key: "qrCodeCount", value: 0 }));
                        dispatch(setUserValue({ key: "address", value: "" }));
                        props.handleLogin(false);
                    }
                });
            } catch (e) {
                console.log("error e: ", e);
            }
        } else {
            alert(t('auth.fillAllFields'));
        }
    }

    return (
        <div className="loginSectionComponent__container">
            <div className="loginSectionComponent__container_content">
                <div
                    className="registrationSectionComponent__container_content-back-button-wrap"
                    onClick={props.handleCloseModal}
                >
                    <img
                        className="registrationSectionComponent__container_content-back-button"
                        src={process.env.PUBLIC_URL + '/images/close-login.svg'}
                        alt="Back to main btn"
                    />
                </div>

                <form className="registrationSectionComponent__container_content_form">
                    <div className="registrationSectionComponent__container_content_form_input_wrap email">
                        <label htmlFor="email">{t('auth.email')}</label>
                        <input
                            type="email"
                            id="email"
                            name="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                        />
                    </div>

                    <div className="registrationSectionComponent__container_content_form_input_wrap password">
                        <label htmlFor="password">{t('auth.password')}</label>
                        <input
                            type="password"
                            id="password"
                            name="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                        />
                    </div>


                </form>

                <div className="registrationSectionComponent__container-button-btn_wrap">
                    <Button
                        className="registrationSectionComponent__container-button-btn registration"
                        variant="contained"
                        onClick={handleButtonFormSubmit}
                    >
                            <span>
                                {t('navbar.logIn')}
                            </span>
                    </Button>
                </div>

                <div className="registrationSectionComponent__container-button-alternative-wrap">
                    <div className="registrationSectionComponent__container-button-alternative">
                        <div className="registrationSectionComponent__container-button-alternative-title">
                            <span>{t('auth.orLoginVia')}</span>
                        </div>
                        <div className="registrationSectionComponent__container-button-alternative-btn">
                            <img src={process.env.PUBLIC_URL + '/images/google-login-icon.png'} alt="Google"/>
                            <img src={process.env.PUBLIC_URL + '/images/apple-login-icon.png'} alt="Apple"/>
                        </div>
                    </div>
                    <div className="registrationSectionComponent__container-button-redirect-to-registration-wrap">
                        <span>{t('auth.noAccountText')} <span className="registrationSectionComponent__container-button-redirect-to-registration-link" onClick={props.redirectToRegistration}>{t('auth.registration')}</span></span>
                    </div>
                </div>

            </div>
        </div>
    );
};

export default LoginSectionComponent;